export { default as Img200 } from './processed/200/Apocalypse-Now.jpg';
export { default as Img400 } from './processed/400/Apocalypse-Now.jpg';
export { default as Imgthumb } from './processed/thumb/Apocalypse-Now.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Apocalypse-Now.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Apocalypse-Now.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      220,
      68,
      28
    ],
    "_population": 1,
    "_hsl": [
      0.034722222222222224,
      0.7741935483870966,
      0.4862745098039216
    ]
  },
  "LightVibrant": {
    "_rgb": [
      252,
      158,
      108
    ],
    "_population": 4,
    "_hsl": [
      0.05787037037037038,
      0.9600000000000002,
      0.7058823529411765
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      132,
      28,
      12
    ],
    "_population": 2,
    "_hsl": [
      0.022222222222222223,
      0.8333333333333335,
      0.2823529411764706
    ]
  },
  "Muted": {
    "_rgb": [
      165,
      97,
      85
    ],
    "_population": 14,
    "_hsl": [
      0.024999999999999994,
      0.32,
      0.4901960784313726
    ]
  },
  "LightMuted": {
    "_rgb": [
      172,
      169,
      177
    ],
    "_population": 3,
    "_hsl": [
      0.729166666666667,
      0.048780487804878044,
      0.6784313725490196
    ]
  },
  "DarkMuted": {
    "_rgb": [
      92,
      42,
      44
    ],
    "_population": 30,
    "_hsl": [
      0.9933333333333333,
      0.3731343283582089,
      0.2627450980392157
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Apocalypse-Now.js